// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ecdfab41","453":"182b811e","732":"0d3e9d39"}[chunkId] + ".chunk.js";
};